import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const MemberGroupContext = createContext()

const MemberGroupProvider = ({ children }) => {

    const { auth, toast } = useAuth();

    const headers = {
        Authorization: auth?.token,
    };

    const getAllMemberGroup = async (filter) => {
        try {
            const { page, search, limit } = filter

            let { data } = await axios.get(`${baseURL}/admin/member/group?filter=${search ? search : null}&limit=${limit ? limit : null}&page=${page ? page : null}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const getAvailableMembers = async (filter) => {
        try {
            const { page, search, limit, group_id } = filter

            let { data } = await axios.get(`${baseURL}/admin/member/group/available-members?filter=${search ? search : null}&limit=${limit ? limit : null}&page=${page ? page : null}&group_id=${group_id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const getSingleMemberGroup = async (id) => {
        try {

            let { data } = await axios.get(`${baseURL}/admin/member/group/${id}`, { headers })

            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const importGroupMembers = async (groupDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/admin/member/group/import`, groupDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    const importGroupMemberSave = async (groupDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/admin/member/group/import/save`, groupDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    const createMemberGroup = async (groupDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/admin/member/group/create`, groupDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    const updateMemberGroup = async (id, groupDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/admin/member/group/update/${id}`, groupDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    const deleteMemberGroup = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/admin/member/group/delete/${id}`, { headers });
            if (data.error === false) {
                toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    return (
        <MemberGroupContext.Provider value={{ createMemberGroup, importGroupMembers, importGroupMemberSave, getAllMemberGroup, getAvailableMembers, getSingleMemberGroup, updateMemberGroup, deleteMemberGroup }}>
            {children}
        </MemberGroupContext.Provider>
    )
}

const useMemberGroup = () => useContext(MemberGroupContext)

export { useMemberGroup, MemberGroupProvider }